<div class="my-3 my-md-5">
  <div class="container-fluid">
    <div class="col-sm-6 float-left">
        <h1 class="page-title">Location List</h1>
    </div>
    <div class="col-sm-6 float-left add_user_btn">
        <a routerLink="/create-location" class="btn btn-success">
          <i class="fa fa-plus" aria-hidden="true"></i> Add Location
      </a>
    </div>

  </div>

  <div class="container-fluid px-4 pt-4 card">
      <mat-accordion class="example-headers-align" multi>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                  <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
              <div class="row mb-4 mt-4">
                  <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text"  placeholder="Search" /></div>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadLocationList(0,perpage)" >
                        <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
              </div>
          </mat-expansion-panel>
  </mat-accordion>
      <div class="card">
          <div class="container-fluid row">
              <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading" (click)="loadLocationList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button></div>
              <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
          </div>
          <div class="tableFixHead" style="overflow: scroll">
          <table class="table table-striped">
              <thead>
                  <tr>
                      <th style="width: 50px;">#</th>
                      <th>City</th>
                      <th>Location</th>
                      <th style="width: 100px;">Status</th>
                      <th style="width: 100px;">Action</th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let location of locationList;let index = index;">
                      <td >{{(pageIndex*perpage)+index+1}}</td>
                      <td>
                          <span *ngIf="!location.cityName">-</span>
                          <span *ngIf="location.cityName">{{location.cityName}}</span>

                      </td>
                      <td>{{location.name}}</td>

                      <td>
                        <span class="badge bg-green-light" *ngIf="location.status=='1'">Active</span>
                        <span class="badge bg-azure-light" *ngIf="location.status=='0'">In-Active</span>
                      </td>
                      <td>
                           <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle" type="button" id="{{location.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  Action
                              </button>
                              <div class="dropdown-menu" aria-labelledby="{{location.id}}">
                                  <a class="dropdown-item" routerLink="/update-location/{{location.id}}"><i class="fa fa-pen"></i> Update</a>
                              </div>
                           </div>
                      </td>
                  </tr>
                  <tr *ngIf="loading">
                      <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                  </tr>
                  <tr *ngIf="loaded && !locationList.length">
                      <td colspan="20" ><i class="far fa-frown"></i> Location not found</td>
                  </tr>
              </tbody>
          </table>
          </div>
          <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
      </div>


        </div>
</div>
